








































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import { tradeWorksheetWebservice } from '@/webservices/tradeWorksheet';
import { pmWorksheetWebservice } from '@/webservices/pmWorksheet';
import { appliedLessonWebservice } from '@/webservices/appliedlesson';
import { Action, Getter } from 'vuex-class';
import type { DynamicField } from '@/models/dynamicField';
import type { Worksheet } from '@/models/worksheet';
import moment from 'moment';
import type { Project } from '@/models/project';
import type { CompanySetting } from '@/models/companySetting';
import PrintSingleWorksheet from '@/components/worksheets/PrintSingleWorksheet.vue';
import { pmAppliedLessonWebservice } from '@/webservices/pmappliedlesson';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';
import { showErrorNotification } from '@/helpers/showErrorNotification';
import { showSuccessNotification } from '@/helpers/showSuccessNotification';
import WorksheetUpdateLessonModal from '@/components/worksheets/WorksheetUpdateLessonModal.vue';
import { toggleModal } from '@/helpers/modal';
import { CombinedUser, getCombinedProjectUsers } from '@/helpers/getCombinedProjectUsers';
import FormDynamicFieldPicker from '@/components/form/FormDynamicFieldPicker.vue';
import ColumnsFilter from '@/components/worksheets/ColumnsFilter.vue';
import { createAppliedLessonsFilter } from '@/helpers/createAppliedLessonsFilter';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';
import AppliedLessonTable from '@/components/worksheets/AppliedLessonTable.vue';
import type { PMWorksheet } from '@/models/pmworksheet';
import { xWorksheetWebservice } from '@/webservices/xworksheet';
import { xAppliedLessonWebservice } from '@/webservices/xappliedlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { XWorksheet } from '@/models/xworksheet';
import WorksheetCreateXAppliedLessonModal from '@/components/worksheets/WorksheetCreateXAppliedLessonModal.vue';
import WorksheetCreateAppliedLessonModal from './WorksheetCreateAppliedLessonModal.vue';
import { debounce } from 'lodash';
import type { User } from '@/models/user';
import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import { findCombinedUser } from '@/helpers/findCombinedUser';
import { resolveLessonTypeByAppliedLessonType } from '@/helpers/resolveLessonType';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import { hasPermission } from '@/helpers/auth/permissionHelpers';

@Component({
    name: 'WorksheetAppliedLessons',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        AppliedLessonTable,
        FormProjectUserPicker,
        FormDynamicFieldPicker,
        PrintSingleWorksheet,
        DetailedConfirmModal,
        WorksheetUpdateLessonModal,
        ColumnsFilter,
        WorksheetCreateXAppliedLessonModal,
    },
})
export default class WorksheetView extends Vue {
    /* Filter */
    get filtered() {
        let lessonsCopy = JSON.parse(JSON.stringify(this.lessons));
        lessonsCopy = this.mapUsersRec(lessonsCopy);

        const filtered = this.onlyPR && !this.showEverything ? this.filterNeedCheckLessons(lessonsCopy) : lessonsCopy;
        if (this.showEverything) {
            return filtered;
        }
        return this.filterUndoneLessons(filtered);
    }

    get users(): CombinedUser[] {
        return getCombinedProjectUsers(this.selectedProject);
    }

    @Prop({
        required: true,
    })
    private id: number;

    @Prop({
        required: false,
        default: false,
    })
    private onlyPR: boolean;

    @Prop({
        required: false,
        default: 'AppliedLesson',
    })
    private type: AppliedLessonType;

    @Prop({
        required: false,
    })
    private highlight: number | null;

    private AppliedLessonType = AppliedLessonType;
    private toggleModal = toggleModal;
    private WorksheetCreateAppliedLessonModal = WorksheetCreateAppliedLessonModal;
    private WorksheetCreateXAppliedLessonModal = WorksheetCreateXAppliedLessonModal;

    private DEBOUNCE_APPLY_UPDATE_INTERVAL = 0; // milliseconds
    private DEBOUNCE_RELOAD_WORKSHEET_INTERVAL = 10; // milliseconds
    private DEBOUNCE_UPDATE_NOTIFICATION_INTERVAL = 2000; // milliseconds
    private isUpdating: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;
    @Getter('project/projects') private projects: Project[];
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('account/userInfo') private userInfo: User;

    /* used in multiselect in template for x fields */
    @Getter('company/dynamicFields') private dynamicFields: DynamicField[];
    @Action('company/fetchAllDynamicFields') private fetchAllDynamicFields: any;

    private tableColumns: AppliedLessonsFilter | null = null;

    private showEverything: boolean = false;

    private worksheet: Worksheet | PMWorksheet | XWorksheet = {} as Worksheet;

    private appliedLessonToUpdate: AppliedLesson = {} as AppliedLesson;
    private lessons = new Array<AppliedLesson | PMAppliedLesson | XAppliedLesson>();

    private debouncedUpdate = debounce(this.applyUpdate, this.DEBOUNCE_APPLY_UPDATE_INTERVAL);
    private debouncedReload = debounce(this.reloadWorksheet, this.DEBOUNCE_RELOAD_WORKSHEET_INTERVAL);
    private debouncedUpdateNotification = debounce(this.updateNotification, this.DEBOUNCE_UPDATE_NOTIFICATION_INTERVAL);

    private confirmRemoveModal = {
        toggled: false,
        loading: false,
    };

    toggleUpdateAppliedLessonModal(value) {
        this.appliedLessonToUpdate = value;

        toggleModal(WorksheetUpdateLessonModal, {
            type: this.type,
            worksheet: this.worksheet,
            saved: this.initialize,
            appliedLessonToUpdate: this.appliedLessonToUpdate,
        });
    }

    initialize(options?: { highlight?: number }) {
        this.loadWorksheet();

        // this currently doesn't work because the backend does not give back the ID of the newly created applied lesson
        if (options && options.highlight) {
            this.highlight = options.highlight;
        }
    }

    lessonsUpdated() {
        this.loadAppliedLessons();
    }

    private mounted() {
        this.tableColumns = createAppliedLessonsFilter(this.companySetting);

        this.initialize();

        this.$watch(
            () => this.id,
            () => {
                this.initialize();
            }
        );

        this.$watch(
            () => this.onlyPR,
            () => {
                this.initialize();
            }
        );

        this.$watch(
            () => this.type,
            () => {
                this.initialize();
            }
        );

        /* Load all Dynamic Fields via vuex */
        this.fetchAllDynamicFields();
    }

    get canPrint() {
        return hasPermission(
            resolveLessonTypeByAppliedLessonType(this.type, {
                x: [PERMISSIONS.APPEX_X_WORKSHEET_PRINT],
                pm: [PERMISSIONS.APPEX_PM_WORKSHEET_PRINT],
                trade: [PERMISSIONS.APPEX_WORKSHEET_PRINT],
            })
        );
    }

    get canAddQuestion() {
        return resolveLessonTypeByAppliedLessonType(this.type, {
            x: () => hasPermission([PERMISSIONS.APPEX_X_WORKSHEET_EDIT, PERMISSIONS.APPEX_X_APPLIED_LESSON_CREATE]),
            pm: () => hasPermission([PERMISSIONS.APPEX_PM_WORKSHEET_EDIT, PERMISSIONS.APPEX_PM_APPLIED_LESSON_CREATE]),
            trade: () => hasPermission([PERMISSIONS.APPEX_WORKSHEET_EDIT, PERMISSIONS.APPEX_APPLIED_LESSON_CREATE]),
        });
    }

    get canDelete() {
        return hasPermission(
            resolveLessonTypeByAppliedLessonType(this.type, {
                x: PERMISSIONS.APPEX_X_WORKSHEET_DELETE,
                pm: PERMISSIONS.APPEX_PM_WORKSHEET_DELETE,
                trade: PERMISSIONS.APPEX_WORKSHEET_DELETE,
            })
        );
    }

    private async applyUpdate(lesson: AppliedLesson | PMAppliedLesson | XAppliedLesson) {
        switch (this.type) {
            case AppliedLessonType.AppliedLesson:
                await appliedLessonWebservice.update(lesson as AppliedLesson).catch(() => {
                    showErrorNotification('toastMessages.error.worksheet');
                });
                break;

            case AppliedLessonType.XAppliedLesson:
                await xAppliedLessonWebservice.update(lesson as XAppliedLesson).catch(() => {
                    showErrorNotification('toastMessages.error.worksheet');
                });
                break;

            case AppliedLessonType.PMAppliedLesson:
                await pmAppliedLessonWebservice.update(lesson as PMAppliedLesson).catch(() => {
                    showErrorNotification('toastMessages.error.worksheet');
                });
                break;
        }

        this.debouncedUpdateNotification();

        this.debouncedReload();
    }

    private updateNotification() {
        showSuccessNotification('toastMessages.update.worksheet');
    }

    private async reloadWorksheet() {
        this.isUpdating = true;
        this.lessonsUpdated();
    }

    private filterNeedCheckLessons(lessons: any[]): AppliedLesson[] {
        return lessons.filter((lesson) => {
            // Keep the lesson if needscheck is true
            if (lesson.needscheck && this.showEverything) {
                return true;
            } else if (lesson.needscheck && !this.showEverything) {
                return (
                    (!lesson.done && !lesson.needscheck && !lesson.checked) ||
                    (!lesson.done && lesson.needscheck) ||
                    (lesson.done && lesson.needscheck && !lesson.checked)
                );
            }

            // Recursively check sub_lessons
            if (lesson.sub_lessons) {
                const filteredSubLessons = this.filterNeedCheckLessons(lesson.sub_lessons);
                if (filteredSubLessons.length > 0) {
                    // If any sub_lessons are kept, keep the parent lesson too
                    lesson.sub_lessons = filteredSubLessons;
                    return true;
                }
            }

            // Otherwise, filter out the lesson
            return false;
        });
    }

    private filterUndoneLessons(lessons: any[]): AppliedLesson[] {
        return lessons.filter((lesson) => {
            // Check if the lesson is undone
            const isUndone =
                (!lesson.done && !lesson.needscheck && !lesson.checked) ||
                (!lesson.done && lesson.needscheck) ||
                (lesson.done && lesson.needscheck && !lesson.checked);

            // If the lesson has sub_lessons, apply the filter recursively
            if (lesson.sub_lessons) {
                lesson.sub_lessons = this.filterUndoneLessons(lesson.sub_lessons);
                // Keep the lesson if it's undone or if any sub_lesson is kept
                return isUndone || lesson.sub_lessons.length > 0;
            }

            // Return the lesson if it's undone
            return isUndone;
        });
    }

    /* Load Worksheet */
    private loadWorksheet() {
        let webservice: any;
        if (this.type === AppliedLessonType.PMAppliedLesson) {
            webservice = pmWorksheetWebservice;
        } else if (this.type === AppliedLessonType.XAppliedLesson) {
            webservice = xWorksheetWebservice;
        } else if (this.type === AppliedLessonType.AppliedLesson) {
            webservice = tradeWorksheetWebservice;
        }

        webservice
            .getById(this.id)
            .then((response) => {
                this.worksheet = response.data;
                this.loadAppliedLessons();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    /* Load Applied Lessons */
    private loadAppliedLessons() {
        let webservice: any;
        if (this.type === AppliedLessonType.PMAppliedLesson) {
            webservice = pmAppliedLessonWebservice;
        } else if (this.type === AppliedLessonType.XAppliedLesson) {
            webservice = xAppliedLessonWebservice;
        } else if (this.type === AppliedLessonType.AppliedLesson) {
            webservice = appliedLessonWebservice;
        }

        webservice
            .getByWorksheetId(this.id)
            .then((response) => {
                this.lessons = response.data;
                this.isUpdating = false;
            })
            .catch((error) => {
                console.error(error);
                this.isUpdating = false;
            });
    }

    private mapUsersRec(lessons: any, mapped: [] = []) {
        mapped = lessons.map((lesson) => {
            lesson.responsible_user = findCombinedUser(this.users, lesson);
            lesson.contacttill = lesson.contacttill ? moment(lesson.contacttill).toDate() : null;
            if (lesson.sub_lessons) {
                lesson.sub_lessons = this.mapUsersRec(lesson.sub_lessons, mapped);
            }
            return lesson;
        });
        return mapped;
    }

    /* Confirm Remove Modal */
    private toggleConfirmRemoveModal(confirmed = false) {
        if (confirmed) {
            this.confirmRemoveModal.loading = true;
            if (this.type === AppliedLessonType.AppliedLesson) {
                tradeWorksheetWebservice
                    .remove(this.worksheet as Worksheet)
                    .then(() => {
                        showSuccessNotification('toastMessages.delete.worksheet');

                        this.$router.push({ path: '/projects' });
                    })
                    .catch(() => {
                        showErrorNotification('toastMessages.error.cannot_remove_worksheet');
                    });
            } else if (this.type === AppliedLessonType.XAppliedLesson) {
                xWorksheetWebservice
                    .remove(this.worksheet as XWorksheet)
                    .then(() => {
                        showSuccessNotification('toastMessages.delete.worksheet');

                        this.$router.push({ path: '/projects' });
                    })
                    .catch(() => {
                        showErrorNotification('toastMessages.error.cannot_remove_worksheet');
                    });
            } else {
                pmWorksheetWebservice
                    .remove(this.worksheet as PMWorksheet)
                    .then(() => {
                        showSuccessNotification('toastMessages.delete.worksheet');

                        this.$router.push({ path: '/projects' });
                    })
                    .catch(() => {
                        showErrorNotification('toastMessages.error.cannot_remove_worksheet');
                    });
            }
        } else {
            this.confirmRemoveModal.toggled = !this.confirmRemoveModal.toggled;
        }
    }
}
